export const MENU_TOP_INDEX = "MENU_TOP_INDEX";
export const MENU_LEFT_INDEX = "MENU_LEFT_INDEX";
export const MENU_LEFT_ITEM_INDEX = "MENU_LEFT_ITEM_INDEX";
export const MENU_LEFT_CONTENT = "MENU_LEFT_CONTENT";

function action(type, payload = {}) {
	return { type, ...payload };
}

export const setMenuTopIndex = index => action(MENU_TOP_INDEX, { index });
export const setMenuLeftIndex = index => action(MENU_LEFT_INDEX, { index });
export const setMenuLeftItemIndex = index =>
	action(MENU_LEFT_ITEM_INDEX, { index });
export const setMenuLeftContent = data => action(MENU_LEFT_CONTENT, { data });



// WEBPACK FOOTER //
// src/redux/actions/menuActions.js